import { render, staticRenderFns } from "./JgpTree2.vue?vue&type=template&id=cd63b142&"
import script from "./JgpTree2.vue?vue&type=script&lang=js&"
export * from "./JgpTree2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports